import { Injectable } from '@angular/core';
import { ProductFamily } from './product-family.model';
import { RestProductFamiliesService } from 'src/app/service/rest/product-families/rest-product-families.service';
import { Observable } from 'rxjs';

@Injectable()
export class ProductFamilyService {
  
  private _productFamily: ProductFamily;
  
  constructor(private restProductFamilyService: RestProductFamiliesService) { }
  
  public get productFamily(): ProductFamily {
    return this._productFamily;
  }
  public set productFamily(value: ProductFamily) {
    this._productFamily = value;
  }
  
  deleteProductFamily(): Observable<any> {
    return this.restProductFamilyService.deleteProductFamily(this.productFamily.id);
  }

  updateProductFamily(): Observable<ProductFamily> {
    return this.restProductFamilyService.updateProductFamily(this.productFamily);
  }

  createProductFamily(): Observable<ProductFamily> {
    return this.restProductFamilyService.createProductFamily(this.productFamily);
  }
}
